import './sweetlilus/style';
import FormStructure from './sweetlilus/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js